import { render, staticRenderFns } from "./Label.vue?vue&type=template&id=6fce81a6&scoped=true"
import script from "./Label.vue?vue&type=script&lang=ts"
export * from "./Label.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fce81a6",
  null
  
)

export default component.exports